export default `---
slug: swift-enterprise-ai
type: work
dateRange: "Feb 2025 – Present"
institution: "Swift"
location: "The Netherlands"
role: "Enterprise AI Team — RAG & Agentforce Lead"
current: true
skills: [Python, Agentforce, Salesforce, RAG, LLM, Prompt Engineering, Enterprise AI, Project Management]
relatedLinks:
  - label: "Salesforce Prompt Builder"
    href: /projects/salesforce-prompt-builder
  - label: "LLM Fine-tuning"
    href: /projects/llm-finetuning
---

In February 2025, I started a trading place in the Enterprise AI team, where I lead a project to implement a RAG-powered chatbot leveraging Agentforce technology. In August 2025, I officially switched teams to become a stable, full-time member of the Enterprise AI team — the place where I belong.

The work is at the intersection of everything I love: AI, enterprise software, regulated environments where getting things right actually matters, and the challenge of building things that real people use every day. The journey from customer support engineer to Enterprise AI team member in three years — through RPA automation, Apziva, the Salesforce Prompt Builder, and a lot of self-driven learning — is the story I'm most proud of professionally. And this is very much just the beginning.
`;
